import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { LySliderModule } from '@alyle/ui/slider';
import { LyButtonModule } from '@alyle/ui/button';
import { LyIconModule } from '@alyle/ui/icon';
import { LyDialogModule } from '@alyle/ui/dialog';

import { PruebasComponent } from './pruebas.component';
import { ModalImgComponent } from './modal-img/modal-img.component';

const rutas = [
  {
    path     : 'pruebas-logo',
    component: PruebasComponent,
    // canActivate: [AuthGuard]
  },
];

@NgModule({
  declarations: [
    PruebasComponent,
    ModalImgComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    LyImageCropperModule,
    LySliderModule,
    LyButtonModule,
    LyIconModule,
    LyDialogModule
  ]
})
export class PruebasModule { }
